/**
 * 显示封面组件
 */
import * as store from '@/store';
import {getMorphoService, serviceNames} from '@/rte/editor';
import ShowCover from '@/assets/svg/ai/show-cover.svg?tsx';
import {feLogger, clickShowCover} from '@/buried';

import styles from './index.module.scss';

interface IProps {
    isHover: boolean;
    docGuid: string;
    showDocCover?: boolean;
    isCardView?: boolean;
}

const AddCover: React.FC<IProps> = ({isHover, docGuid, showDocCover = false, isCardView = false}) => {
    const handleShowCover = async () => {
        const coverConfig = getMorphoService(serviceNames.ICoverService);
        if (coverConfig && coverConfig.setShowDocCover) {
            coverConfig.setShowDocCover(true);
            store.setShowDocCover(true);

            feLogger(clickShowCover({
                pageId: docGuid || '',
            }));
        }
    };

    const isShowEntry = isHover && !showDocCover && !isCardView;

    return (
        <div className={styles.wrapperBox}>
            {isShowEntry && (
                <div className={styles.wrapper} onClick={handleShowCover}>
                    <ShowCover className={styles.icon} />
                    <div className={styles.text}>显示封面</div>
                </div>
            )}
        </div>
    );
};

export default store.connect([
    store.KEYS.SHOW_DOC_COVER,
])(AddCover);
